import {Component, Input} from '@angular/core';
import {MaterialWykonczenia} from '../../../../../../../../../../services/slownik/types/material-wykonczenia';
import {SelectType} from '../../../../../../../../../ui/select/select.component';
import {UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'shared-material-wykonczenia',
  templateUrl: './material-wykonczenia.component.html'
})

export class MaterialWykonczeniaComponent {

  @Input()
  formularz!: UntypedFormGroup;

  @Input()
  rodzajeMaterialowWykonczenia: MaterialWykonczenia[] = [];

  konwertujMaterialyWykonczenia(materialyWykonczenia: MaterialWykonczenia[]): SelectType[] {
    return materialyWykonczenia.map(material => ({kod: material.nazwa, opis: material.opis} as SelectType))
  }
}


